import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import Moment from 'moment'
import * as R from 'ramda'

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';

import CommentNotifications from '../CommentNotifications'
import AttachmentsList from '../Attachments/AttachmentsList'
import AttachmentCard from '../Attachments/AttachmentCard'

import { doc, makeRefSelector } from 'selectors/common'
import { commentManagerAvatar } from 'selectors/attachments'
import { owners } from 'selectors/entities'

import commentActions from 'actions/commentActions'

import { linkedText } from 'utils/commentsText'

let select = (state, props) => ({
	comment: doc(state, props.commentID)
  , data: state.data
  , managerAvatar: commentManagerAvatar(state, props.commentID)
  , userID: state.session.userID
  , manager: makeRefSelector('userID')(state, props.commentID)
  , owners: owners(state)
})

export class CommentCard extends Component {
	render(){
		let { props } = this
		return(
			(props.comment)?
			<div
				className="comment-card"
				key={props.comment._id}
				style={{
					display: "flex"
				  , marginBottom: "15px"
				}}
			>
				<div
					className="avatar-holder"
					style={{
						minWidth: "32px"
					  , width: "32px"
					  , marginRight: "10px"
					  , marginTop : "0"
					}}
				>
					{(props.manager && props.managerAvatar)?
						<Link
							to={'/manager/manager/' + props.manager._id}
							style={{cursor: "pointer"}}
						>
							<AttachmentCard attachmentID={props.managerAvatar._id} avatar={true} />
						</Link>
						:
						<img
							src={'/' + process.env.REACT_APP_NAME + "/static/img/res/avatar.png"}
							style={{
								width: '32px'
							  , height:'32px'
							  , display: 'inline-block'
							}}
						/>
					}
				</div>
				<div
					className="body"
					style={{
						overflow: 'hidden'
					  , overflow: "auto"
					  , display: "inline-block"
					  , width: "100%"
					  , marginBottom: "1px"
					}}
				>
					<div
						className="author"
						style={{fontWeight: 'bold'}}
					>
						{(props.manager && props.manager.name)?
							<Link
								to={'/manager/manager/' + props.manager._id}
								style={{cursor: "pointer", color: "#000", textDecoration: "none", fontWeight: 'bold'}}
							>
								 {props.manager.name}
							</Link>
							:
							(props.comment && props.comment.userID && props.owners[props.comment.userID] && props.owners[props.comment.userID].firstName) || props.comment.createdBy
						}
					</div>
					<div
						className="time"
						style={{
							marginBottom: "10pt"
						}}
					>
						<span style={{fontSize: "12px", color:"#bec7cb"}}>
							{`${Moment(props.comment.createdAt || props.comment.updatedAt).format('MMM DD YYYY h:mma')}`}
						</span>
					</div>

					<div className="text" style={{width: "100%"}}>
						{
							linkedText(props.comment.contents)
						}
					</div>
					<div className="attachments" >
						<AttachmentsList objectID={props.commentID} removable={false} icon={true} />
					</div>
					<CommentNotifications commentID={props.comment._id} />
				</div>
				{(props.comment.userID == props.userID)?
					<div
						className="buttons-comment"
						style={{
							position: "absolute"
						  , minWidth: "40px"
						  , right: "15px"
						}}
					>
						<IconMenu
							iconButtonElement={
								<svg
									width="16px"
									height="14px"
									viewBox="0 0 49 59"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									xmlnsXlink="http://www.w3.org/1999/xlink"
									style={{
										cursor: "pointer"
									}}
								>
									<title>delete</title>
									<desc>Created with Sketch.</desc>
									<defs></defs>
									<g id="Page-1" stroke="none" strokeWidth="2" fill="none" fillRule="evenodd">
										<g id="delete" fill="#fc6a5a">
											<g id="Group">
												<path d="M24.5,51 C25.052,51 25.5,50.553 25.5,50 L25.5,17 C25.5,16.447 25.052,16 24.5,16 C23.948,16 23.5,16.447 23.5,17 L23.5,50 C23.5,50.553 23.948,51 24.5,51 L24.5,51 Z" id="Shape"></path>
												<path d="M14.5,51 C15.052,51 15.5,50.553 15.5,50 L15.5,17 C15.5,16.447 15.052,16 14.5,16 C13.948,16 13.5,16.447 13.5,17 L13.5,50 C13.5,50.553 13.948,51 14.5,51 L14.5,51 Z" id="Shape"></path>
												<path d="M34.5,51 C35.052,51 35.5,50.553 35.5,50 L35.5,17 C35.5,16.447 35.052,16 34.5,16 C33.948,16 33.5,16.447 33.5,17 L33.5,50 C33.5,50.553 33.948,51 34.5,51 L34.5,51 Z" id="Shape"></path>
												<path d="M47.5,6 L33.456,6 C33.346,4.75 32.961,2.642 31.643,1.289 C30.809,0.434 29.751,0 28.499,0 L18.5,0 C17.248,0 16.19,0.434 15.356,1.289 C14.038,2.642 13.653,4.75 13.543,6 L1.5,6 C0.948,6 0.5,6.447 0.5,7 C0.5,7.553 0.948,8 1.5,8 L3.541,8 L5.456,54.021 C5.493,55.743 6.565,59 10.364,59 L38.636,59 C42.435,59 43.507,55.743 43.543,54.042 L45.459,8 L47.5,8 C48.052,8 48.5,7.553 48.5,7 C48.5,6.447 48.052,6 47.5,6 L47.5,6 Z M16.792,2.681 C17.24,2.223 17.799,2 18.5,2 L28.499,2 C29.2,2 29.759,2.223 30.207,2.681 C31.012,3.504 31.335,4.952 31.447,6 L15.553,6 C15.665,4.952 15.988,3.504 16.792,2.681 L16.792,2.681 Z M41.544,53.979 C41.538,54.288 41.4,57 38.636,57 L10.364,57 C7.63,57 7.466,54.283 7.455,53.958 L5.542,8 L43.457,8 L41.544,53.979 L41.544,53.979 Z" id="Shape"></path>
											</g>
										</g>
									</g>
								</svg>
							}
							onChange={(evt, value) => {
								(value == "delete")? props.COMMENT_DELETE_YES(props.comment._id) : ""
							}}
							anchorOrigin={{horizontal: 'left', vertical: 'top'}}
							targetOrigin={{horizontal: 'left', vertical: 'top'}}
						>
							<MenuItem primaryText="Delete" value="delete"/>
							<MenuItem primaryText="Cancel" value="cancel"/>
						</IconMenu>

						<img
							src={".." + "/static/img/pencil-edit.png"}
							style={{
								width: "14px"
							  , margin: "0"
							  , marginLeft: "10px"
							  , cursor: "pointer"
							}}
							onClick={()=> props.COMMENT_EDIT({
								_id: props.comment._id
							  , contents: props.comment.contents
							})}
						/>
					</div>
					:""
				}
			</div>
			:
			<div></div>
		)
	}
}

export default connect(select, commentActions)(CommentCard)



// WEBPACK FOOTER //
// ./src/components/Comments/CommentCard.js